import { FormattedMessage as FM } from "react-intl";

import Tooltip from "componentsv2/widgets/Tooltip";
import { ICON_COLORS } from "components/Constants/constants";
import { cn } from "tools/ui";
import {
  ArrowLeftIcon,
  PencilSquareIcon,
  SaveIcon,
  TrashIcon,
  PlusIcon,
} from "components/Icons";

const base =
  "flex my-auto h-10 border border-neutral-400 shadow-md cursor-pointer rounded-xl py-2 px-3 items-center text-center hover:opacity-90 disabled:opacity-50 active:scale-95 hover:shadow-sm";
const ICON_STYLE = "flex my-auto fill-current w-5 h-5";

function IconButton({ name, style, color, disabled, onClick, label, content }) {
  function handleClick(e) {
    e.preventDefault();
    onClick(name);
  }

  let _size = "";
  // if (size) {
  //   _size = size;
  // }

  const [bgColor, iconColor] = ICON_COLORS[color || "blue"];
  const _disabled = disabled ? disabled : false;

  const Icons = {
    back: {
      icon: (
        <ArrowLeftIcon key={name} className={cn(ICON_STYLE, name, iconColor)} />
      ),
    },
    edit: {
      icon: (
        <PencilSquareIcon
          key={name}
          className={cn(ICON_STYLE, name, iconColor)}
        />
      ),
    },
    save: {
      icon: <SaveIcon key={name} className={cn(ICON_STYLE, iconColor)} />,
    },
    delete: {
      icon: <TrashIcon key={name} className={cn(ICON_STYLE, iconColor)} />,
    },
    add: {
      icon: <PlusIcon key={name} className={cn(ICON_STYLE, iconColor)} />,
    },
  };

  const targetIcon = Icons[name].icon;
  const windowWidth = window.innerWidth;
  if (content && windowWidth > 1000) {
    content = (
      <span className={cn("text-sm mx-2", iconColor)}>
        <FM id={content} name={content} />
      </span>
    );
  }
  return (
    <div
      onClick={handleClick}
      className={cn(base, style, bgColor)}
      disabled={_disabled}
    >
      {content}
      {targetIcon}
      {label && <Tooltip tooltip={label} />}
    </div>
  );
}

export default IconButton;
